import { render, staticRenderFns } from "./Walmart.vue?vue&type=template&id=7b4e2e12&scoped=true"
import script from "./Walmart.vue?vue&type=script&lang=js"
export * from "./Walmart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e2e12",
  null
  
)

export default component.exports